import { WasmHandler } from "react-lib/frameworks/WasmController";
import {
  deTinyLocation2,
  getLocationsSet,
  getNickName,
  getOnlyFullTeeth,
  tidyLocation2,
} from "react-lib/apps/common/CUDENT/DentalRecordUtil";

import DentalExaminationList from "issara-sdk/apis/DentalExaminationList_apps_DEN";
import DentalExaminationImageList from "issara-sdk/apis/DentalExaminationImageList_apps_DEN";
import DivisionList from "issara-sdk/apis/DivisionList_core";
import DoctorList from "issara-sdk/apis/DoctorList_core";
import PatientSupernumeraryToothList from "issara-sdk/apis/PatientSupernumeraryToothList_apps_DEN";
import PatientSupernumeraryToothDetail from "issara-sdk/apis/PatientSupernumeraryToothDetail_apps_DEN";

import { MissingToothClinical, PartialMissingToothClinical } from "./DiagnosisTodayInterface";
import DentalMedicalHistoryList from "issara-sdk/apis/DentalMedicalHistoryList_apps_DEN";
import EncounterPatientListOptimized from "issara-sdk/apis/EncounterPatientListOptimized_core";
import PeriodontiumRecordList from "issara-sdk/apis/PeriodontiumRecordList_apps_DEN";
import TreatmentPlanList from "issara-sdk/apis/TreatmentPlanList_apps_DEN";
import { isValidDate } from "react-lib/utils/dateUtils";
import { formatDateToYYYYMMDD } from "react-lib/utils/index";

import { GetTreatmentIssue, TreatmentPlanStateInitial } from "./TreatmentTodayInterface";

type Handler = WasmHandler<any, any>;

const DentalTissueMapPane = {
  baby_tooth: "primary_teeth",
  tooth: "permanent_teeth",
  "Head & Neck": "face",
  "Muscle & TMJ": "muscle",
  Periodontium: "periodontium",
  "Oral cavity": "soft",
  "Jaw-bones": "jaw",
  Odontogram: "odontogram",
};

export const GetExamination: Handler = async (controller, params) => {
  controller.setState({ isMainLoading: true });

  let isHistoryVisitReviewJob = false;
  let isHistoryTreatmentReviewJob = false;
  let isHistoryExaminationReviewJob = false;
  if (params.visit) {
    isHistoryVisitReviewJob = true;
    delete params.visit;
  } else if (params.history) {
    isHistoryExaminationReviewJob = true;
    delete params.history;
  } else if (params.treatment) {
    isHistoryTreatmentReviewJob = true;
    delete params.treatment;
  }
  const clinicalAll = await GetDentalExamination(controller, params);

  if (!clinicalAll) {
    controller.setState({ isMainLoading: false });
    return;
  }

  let imageItems = await GetExaminationImageList(controller, { encounter: params.encounter });
  //Process items clinicalAll to get ClinicalTags and convert all location to tiny word
  let missingTooths = [];
  clinicalAll.forEach((item) => {
    if (item.id) {
      if (item.locations_name.length > 0) {
        const locationsSet = getLocationsSet(item.locations_name, controller.data.organ.items);

        item.locations_name = tidyLocation2(locationsSet, controller.data.organ.items).join(",");
      }
      if (item.clinical_findings.length > 0) {
        item.clinicaltags = item.clinical_findings
          .flatMap((id: number) => {
            const tag = controller.data.clinicaltags?.items?.find((item: any) => item.id === id);
            return !!tag ? [tag.name] : [];
          })
          .join(", ");

        // console.log("ClinicalTags:", item.clinicaltags);
        // set missing teeth
        // if (item.clinicaltags.split(",").filter((o) => MissingToothClinical.includes(o.trim())).length > 0) {
        //   // item.locations_name.isInteger()
        //   console.log("locations:", deTinyLocation2(item.locations_name.split(","), controller.data.organ.items));
        // }
      }
      if (!item?.medical_description) {
        item.medical_description = "";
      }
      if (imageItems.length > 0 && imageItems.filter((image) => image.examination === item.id).length > 0) {
        item.image = {};
        item.imageId = {};
        imageItems
          .filter((image) => image.examination === item.id)
          .forEach((img) => {
            item.image[DentalTissueMapPane[img.tissue_name]] = img.image;
            item.imageId[DentalTissueMapPane[img.tissue_name]] = img.id;
          });
      }
    }
  });

  if (isHistoryVisitReviewJob === true) {
    controller.setState({
      isMainLoading: false,
      historyVisitClinicalFindingList: clinicalAll,
      historyVisitFilterClinicalFindingIds: clinicalAll.map((item) => item.id),
      historyVisitClinicalFindingId: null,
      historyVisitClinicalFindingIndex: null,
    });
  } else if (isHistoryTreatmentReviewJob === true) {
    controller.setState({
      isMainLoading: false,
      historyTreatmentClinicalFindingList: clinicalAll,
      historyTreatmentFilterClinicalFindingIds: clinicalAll.map((item) => item.id),
      historyTreatmentClinicalFindingId: null,
      historyTreatmentClinicalFindingIndex: null,
    });
  } else if (isHistoryExaminationReviewJob === true) {
    controller.setState({
      isMainLoading: false,
      historyClinicalFindingList: clinicalAll,
      historyFilterClinicalFindingIds: clinicalAll.map((item) => item.id),
      historyClinicalFindingId: null,
      historyClinicalFindingIndex: null,
    });
  } else {
    controller.setState({
      isMainLoading: false,
      clinicalFindingList: clinicalAll,
      filterClinicalFindingIds: clinicalAll.map((item) => item.id),
      clinicalFindingId: null,
      clinicalFindingIndex: null,
    });
  }
};

const GetDentalExamination: Handler = async (controller, params) => {
  const [result, e1, n1] = await DentalExaminationList.list({
    apiToken: controller.apiToken,
    params,
  });
  if (e1) {
    console.log(e1, n1);
    return [];
  } else {
    return result.items;
  }
  console.log("GetExamination APITOKEN DPOI: result ", result);
};

export const GetExaminationImageList: Handler = async (controller, params) => {
  const [r, e, n] = await DentalExaminationImageList.list({
    apiToken: controller.apiToken,
    params: params,
  });
  if (e) {
    console.log(e);
    return [];
  }

  return r.items;
};

export const AddClinicalFinding: Handler = async (controller, params) => {
  const state = controller.getState();
  const clinicalFindings = state.clinicalFindingList || [];
  const encounter = state.encounterList?.filter((item) => item.id === state.encounterId)?.[0];
  let clinicalFinding: any = {
    location: "",
    encounter: encounter?.id,
    encounterId: encounter?.id,
    patientId: state.patientId,
    toothRecord: {
      condition: "",
      diagnosis: "",
      treatmentplan: "",
    },
  };

  const [r, e, n] = await DentalExaminationList.create({
    apiToken: controller.apiToken,
    data: clinicalFinding,
  });
  if (e) {
    console.log("AddExamination error:", e);
    return;
  }

  clinicalFinding.id = r.id;
  clinicalFinding.medical_description = "";
  clinicalFinding.locations_name = "";
  // controller.db
  //   .collection("ClinicalFinding")
  //   .add(clinicalFinding)
  //   .then((res) => {
  //     console.log(res.id);
  //     clinicalFinding.id = res.id;

  const newClinicalFindings = [...clinicalFindings, clinicalFinding];
  // console.log("newClinicalFindings", newClinicalFindings)
  controller.setState({
    clinicalFindingList: newClinicalFindings,
    filterClinicalFindingIds: newClinicalFindings.map((item) => item.id),
  });
};

export const RemoveClinicalFindingById: Handler = async (controller, params) => {
  const state = controller.getState();
  const examination = state.clinicalFindingList.filter((item) => item.id === params.id)[0];
  try {
    controller.handleEvent({ message: "RemoveClinicalFinding", params: examination });
    // controller.handleEvent({ message: "GetExamination", params: { encounter: controller.getState().encounterId } });
  } catch (e) {
    console.log("Error removing record " + params.id + e.toString());
  }
};

export const GetSpecialToothByExaminations: Handler = async (controller, params) => {
  const { clinicalFindingList, patientDetail } = controller.getState();
  // Start Duplicate code to DentalRecord1
  let missingTeeths = [];
  let partialMissingTeeths = [];
  let implantTeeths = [];
  const organItems = controller.data?.organ?.items;
  for (const exam of clinicalFindingList) {
    if (exam.clinicaltags && exam.clinicaltags.split(",").filter((o) => MissingToothClinical.includes(o.trim())).length > 0) {
      let teethLocations = exam.locations_name.split(",").map((item) => item.trim());
      missingTeeths = missingTeeths.concat(getOnlyFullTeeth(teethLocations, organItems).map((item) => item.nickName));
    }

    if (exam.clinicaltags && exam.clinicaltags.split(",").filter((o) => PartialMissingToothClinical.includes(o.trim())).length > 0) {
      let teethLocations = exam.locations_name.split(",").map((item) => item.trim());
      partialMissingTeeths = partialMissingTeeths.concat(getOnlyFullTeeth(teethLocations, organItems).map((item) => item.nickName));
    }

    if (exam.clinicaltags && exam.clinicaltags.split(",").filter((o) => "Implant" === o.trim()).length > 0) {
      let teethLocations = exam.locations_name
        .split(",")
        .map((item) => item.trim())
        .filter((item) => !item.startsWith("S"));
      implantTeeths = implantTeeths.concat(getOnlyFullTeeth(teethLocations, organItems).map((item) => item.nickName));
    }
  } // end for

  // Unique
  missingTeeths = [...new Set(missingTeeths)];
  implantTeeths = [...new Set(implantTeeths)];
  partialMissingTeeths = [...new Set(partialMissingTeeths)];

  let missingteeth = missingTeeths.map((item) => {
    return controller.data.organ.items.find((o) => o.nickName === item);
  });

  let partialmissingteeth = partialMissingTeeths.map((item) => {
    return controller.data.organ.items.find((o) => o.nickName === item);
  });

  let implantteeth = implantTeeths.map((item) => {
    return controller.data.organ.items.find((o) => o.nickName === item);
  });

  const missingTeeth = patientDetail.missingteeth;

  await controller.setState({
    patientDetail: {
      ...patientDetail,
      partialmissingteeth: partialmissingteeth,
      missingteeth: missingteeth,
      implantteeth: implantteeth,
    },
  });

  if (missingteeth.toString() !== missingTeeth?.toString()) {
    controller.handleEvent({ message: "RecalPlaqueBleed", params: {} });
  }
};

export const GetSuperToothList: Handler = async (controller, params) => {
  const { patientDetail } = controller.getState();
  const [r, e, n] = await PatientSupernumeraryToothList.list({
    apiToken: controller.apiToken,
    params: params,
  });
  if (e) {
    console.log("GetSuperToothList error:", e);
  } else {
    let superTeethItem = [];
    if (r.items.length > 0) {
      superTeethItem = r.items.map((item) => {
        item.nickName = "T" + controller.data.organ?.items.find((o) => o.id === item.code)?.nickName;
        return item;
      });
      superTeethItem = superTeethItem.filter((o) => o.status === "ADD");
    }
    controller.setState({
      patientSuperteethId: params.patient,
      supernumeraryteeth: superTeethItem,
    });
  }
};

export const SetSuperTooth: Handler = async (controller, params) => {
  // console.log(params)
  const state = controller.getState();

  const savedClinicalFindingIndex = state.clinicalFindingIndex;
  const savedClinicalFindingId = state.clinicalFindingId;

  const toothIdSL = typeof params === "string" ? params : params.tooth;
  const createExam = typeof params === "object" ? params.createExam !== false : true;

  const teethNickName = toothIdSL.replace("T", "");

  // const patientId = state.encounterInfo.patientId.toString()
  const patientId = state.patientId;
  let superTeeth = state.supernumeraryteeth || [];

  const [r, e, n] = await PatientSupernumeraryToothList.create({
    apiToken: controller.apiToken,
    data: {
      patient: patientId,
      encounter: state.encounterId,
      location_name: controller.data.organ.items.filter((o) => o.nickName === teethNickName)[0].fullName,
      status: "ADD",
      createExam: createExam.toString(),
    } as any,
  });
  if (e) {
    console.log(e);
    return;
  }

  superTeeth.push({ ...r, nickName: "T" + controller.data.organ.items.find((o) => o.id === r.code).nickName });
  await GetExamination(controller, { encounter: state.encounterId });
  controller.setState({
    supernumeraryteeth: superTeeth,
    clinicalFindingIndex: savedClinicalFindingIndex,
    clinicalFindingId: savedClinicalFindingId,
  });
};

export const UnSetSuperTooth: Handler = async (controller, params) => {
  const state = controller.getState();

  const savedClinicalFindingIndex = state.clinicalFindingIndex;
  const savedClinicalFindingId = state.clinicalFindingId;

  // const patientId = state.encounterInfo.patientId.toString()
  let unSetTeethNickName = controller.data.organ.items.find((o) => o.nickName === params.replace("T", "")).id;
  const patientId = state.patientId;
  let superTeeth = [...state.supernumeraryteeth] || [];
  let superTeethId = superTeeth.find((o) => o.code === unSetTeethNickName).id;
  superTeeth = superTeeth.filter((item) => item.code !== unSetTeethNickName);

  const [r, e, n] = await PatientSupernumeraryToothDetail.patch({
    pk: superTeethId,
    apiToken: controller.apiToken,
    data: {
      active: false,
    },
  });
  await GetExamination(controller, { encounter: state.encounterId });
  controller.setState({
    supernumeraryteeth: superTeeth,
    clinicalFindingIndex: savedClinicalFindingIndex,
    clinicalFindingId: savedClinicalFindingId,
  });
  // TODO: Need Binding API / Check logic
  // controller.db
  //   .collection("PatientDetail")
  //   .doc(patientId)
  //   .update({
  //     supernumeraryteeth: superTeeth,
  //   })
  //   .then((res: any) => {
  //     controller.db
  //       .collection("PatientDetail")
  //       .doc(patientId)
  //       .get()
  //       .then((res: any) => {
  //         controller.setState({
  //           patientDetail: res.data(),
  //         });
  //       });
  //   });
};

export const SetHideBabyTooth: Handler = (controller, params) => {
  const { patientDetail } = controller.getState();

  // const patientId = state.encounterInfo.patientId.toString()

  // console.log(" SetHideBabyTooth ")

  controller.setState({
    patientDetail: {
      ...patientDetail,
      hideBabyTooth: true,
    },
  });
  // TODO: Need Binding API / Check logic
  // controller.db
  //   .collection("PatientDetail")
  //   .doc(patientId)
  //   .update({
  //     hideBabyTooth: true,
  //   })
  //   .then((res: any) => {
  //     controller.db
  //       .collection("PatientDetail")
  //       .doc(patientId)
  //       .get()
  //       .then((res: any) => {
  //         controller.setState({
  //           patientDetail: res.data(),
  //         });
  //       });
  //   });
};

export const UnsetHideBabyTooth: Handler = (controller, params) => {
  const { patientDetail } = controller.getState();

  // const patientId = state.encounterInfo.patientId.toString()
  // const patientId = state.encounterList[state.encounterIndex].patientId.toString();
  // console.log(" UnsetHideBabyTooth ")
  controller.setState({
    patientDetail: {
      ...patientDetail,
      hideBabyTooth: false,
    },
  });
  // TODO: Need Binding API / Check logic
  // controller.db
  //   .collection("PatientDetail")
  //   .doc(patientId)
  //   .update({
  //     hideBabyTooth: false,
  //   })
  //   .then((res: any) => {
  //     controller.db
  //       .collection("PatientDetail")
  //       .doc(patientId)
  //       .get()
  //       .then((res: any) => {
  //         controller.setState({
  //           patientDetail: res.data(),
  //         });
  //       });
  //   });
};

export const SelectedDiagramItem: Handler = (controller, params) => {
  let toothFilter = params.selectedDiagram;
  const organItems = controller.data?.organ?.items;
  let clinicalFindingList = controller.getState().clinicalFindingList;
  if (toothFilter) {
    console.log("toothFilter", toothFilter); // T31-csn, T31-cs, T41-3

    if (toothFilter.substring(0, 1) === "T") {
      let section = toothFilter.substring(4, 5);
      let qi = toothFilter.substring(1, 3);

      let nickName = [];

      if (section === "c") {
        let ssnl = toothFilter.substring(5).toUpperCase();
        console.log("ssnl: ", ssnl);
        // super teeth
        // let filter = getNickName(toothFilter, organItems);
        // console.log("filte super teeth r" ,filter )
        let id = "supertooth" + qi + ssnl;
        console.log("id: ", id);

        let superToothOrgan = organItems.find((item) => item.id === id);
        if (superToothOrgan) {
          nickName.push(superToothOrgan.nickName);
        }
      } else {
        // normal teeth

        if (section !== "5") {
          // partial teeth
          let filter = getNickName(toothFilter, organItems); // e.g. {id: "tooth46B", tissue: "tooth", nickName: "46B", fullName: "4-6 Buccal", primary: "46"...}
          if (filter) {
            nickName = [filter.nickName];
          }
        } else if (section === "5") {
          for (let index = 0; index < 5; index++) {
            nickName.push(getNickName("T" + qi + "-" + index, organItems).nickName);
          }
          // whole teeth
          // let tooth = toothDetails.find(item => item.i === Number(i) && item.q === Number(q))
          // nickName = [...tooth.surfaceName.slice(1,-1)]
          // nickName = nickName.map(item => getNickName(item, organItems))
        }
      }

      let filterCFId = clinicalFindingList?.filter((item) => {
        let child = deTinyLocation2(item.locations_name.split(","), organItems);
        let foundTooth = true;
        nickName.forEach((nick) => {
          if (!child.includes(nick)) {
            foundTooth = false;
          }
        });

        return foundTooth;
      });
      filterCFId = filterCFId.map((item) => item.id);

      // Super Teeth

      /// Tooth selected

      // console.log("SelectedDiagramItem ~ filter", filter)
      // // console.log("SelectedDiagramItem clinicalFindingList", clinicalFindingList)
      // let filterCFId = [];
      //   filterCFId = filterCFId.map((item) => item.id);
      // } else {
      //   // Tooth that can get nickname mean superteeth  // { selectedDiagram: "T36-cs" }
      //   if (toothFilter.substring(4, 5) === "c") {
      //     let superTeeth =
      //       toothFilter.substring(1, 2) +
      //       toothFilter.substring(2, 3) +
      //       toothFilter.substring(5).toUpperCase();
      //     filterCFId = clinicalFindingList?.filter((item) => {
      //       let child = deTinyLocation2(item.location.split(","), organItems);
      //       console.log("  child ", child);
      //       console.log("superTeeth", superTeeth);
      //       return child.includes(superTeeth);
      //     });
      //     filterCFId = filterCFId.map((item) => item.id);
      //   }
      // }

      controller.setState({
        filterClinicalFindingIds: filterCFId,
        filterItem: toothFilter,
      });
    }
    // console.log("🚀 ~ file: DPOI.ts ~ line 723 ~ nickName", nickName)
    // console.log("🚀 ~ file: DPOI.ts ~ line 686 ~ toothFilter", toothFilter)
  } else {
    let all = clinicalFindingList.map((item) => item.id);
    controller.setState({ filterClinicalFindingIds: all, filterItem: null });
  }
};

export const GetDivisionSearch: Handler = async (controller, params) => {
  const [r, e, n] = await DivisionList.list({
    apiToken: controller.apiToken,
    params: { ...params, limit: 99999 },
  });
  if (e) {
    console.log("division search list error", e);
    return [[], e];
  }
  return [r.items, e];
};

export const GetDoctorSearch: Handler = async (controller, params) => {
  let items: any[] = [];

  if (params.exclude_student) {
    const promiseArr = [{ student_flag: false }, { teacher_flag: true }].map((flag) =>
      DoctorList.list({
        apiToken: controller.apiToken,
        params: {
          search: params.search,
          ...flag,
          limit: 99999 },
        ...(params.lang && { extra: { headers: { "Accept-Language": params.lang } } }),
      })
    );

    const response = await Promise.all(promiseArr);
    items = response.flatMap((res) => res[0]?.items || []);
    // Issue 69715
    let uniqueIdList = [...new Set(items.map((i: any) => i.id))]
    items = uniqueIdList.map((id: any) => items.find((i: any) => i.id === id))

  } else {
    const [r] = await DoctorList.list({
      apiToken: controller.apiToken,
      params: {
        ...params,
        limit: 99999 },
      ...(params.lang && { extra: { headers: { "Accept-Language": params.lang } } }),
    });

    items = r?.items || [];
  }

  return [items, null];
};


/* ------------------------------------------------------ */

/*                     Dental History                      */

/* ------------------------------------------------------ */

// ค่าเริ่มต้นของ Dental History
export const HistoryStateInitial = {
  hideTreatmentForm: true,
  treatmentRecord: "",
  historyDate: {},
  selectedHistoryVisit: {
    active: true,
    additional_comment: "",
    chief_complaints: "",
    treatment_name: "",
    created: "",
    approve_status: "",
    division_name: "",
    doctor_fullname: "",
    edit_user: null,
    edited: "",
    encounter: null,
    encounter_started: null,
    encounter_ended: null,
    encounter_checkin_time: null,
    encounter_checkout_time: null,
    encounter_type: null,
    emr: null,
    id: null,
    present_illness: "",
    student_name: "",
    started: "",
    patient_file: null,
    pictures: null,
  },
  selectedHistoryEx: {
    id: null,
    edit_user: null,
    created: "",
    edited: "",
    encounter: null,
    started: "",
    other_clinical_finding: "",
    clinical_findings_name: "",
    division_name: "",
    doctor_name: "",
    edit_user_name: "",
    diagnosis: "",
    other_investigation: "any",
    prognosis: "",
    active: "",
    locations: "",
    locations_name: "",
    clinical_findings: "",
    medical_description: "",
    icd10_med_term: "",
    icd10: "",
    icd10_label: "",
    dental_treatment_plan_label: "",
    image: "",
    imageId: "",
  },
  selectedHistoryTp: {
    created: "",
    description: "",
    display_seq: null,
    division: null,
    doctor: null,
    edit_user: null,
    edited: "",
    estimate_visit: null,
    examination: null,
    examination_location: "",
    examination_principal_diagnosis: "",
    id: null,
    started: "",
    status: "",
    status_label: "",
    treatment: {},
    treatment_issue: {
      treatment_record: "",
    },
    urgency: "",
    urgency_label: "",
  },
  historyReviewVisitData: [],
  historyReviewExData: [],
  historyReviewTpData: [],
  openModalFilter: false,
  openModalFilterClinic: false,
  openModalFilterLocation: false,
  openModalFilterLocationTp: false,
  openModalDoctorExFilter: false,
  openModalDoctorTpFilter: false,
  openModalFilterClinicEx: false,
  openModalFilterClinicTp: false,
  openModalFilterClinicalFinding: false,
  openModalFilterTreatmentCodeTp: false,
  openModalFilterTreatmentTp: false,
  openModalFilterStatus: false,
  openModGallery: null,

  historyClinicalFindingList: [],
  historyVisitClinicalFindingList: [],
  historyTreatmentClinicalFindingList: [],
  historyFilterClinicalFindingIds: [],
  historyVisitFilterClinicalFindingIds: [],
  historyTreatmentFilterClinicalFindingIds: [],
  historyClinicalFindingId: null,
  historyVisitClinicalFindingId: null,
  historyTreatmentClinicalFindingId: null,
  historyClinicalFindingIndex: null,
  historyVisitClinicalFindingIndex: null,
  historyTreatmentClinicalFindingIndex: null,
  historyReviewSubTab: 0,

  doctorFilterList: [],
  doctorFilterListEx: [],
  clinicFilterList: [],
  clinicFilterListEx: [],
  doctorFilterListTp: [],
  clinicFilterListTp: [],
  locationFilterList: [],
  locationFilterListTp: [],
  treatmentFilterListTp: [],
  treatmentCodeFilterListTp: [],
  statusFilterList: [],
  clinicalFindingFilterList: [],
  cloneHistoryReviewVisitSearchData: [],
  cloneHistoryReviewExSearchData: [],
  cloneHistoryReviewTpSearchData: [],
};

export const ChangeHistoryReviewSubTab: Handler = async (controller, params) => {
  controller.setState({ historyReviewSubTab: params.historyReviewSubTab });
};

export const handleGetHistoryVisit: Handler = async (controller) => {
  const state = controller.getState();

  let visitList: any[] = [];

  if (controller.getState().patientId) {
    const param = {
      patient: state.patientId,
      start_date: getValidHistoryDate(state.historyDate?.visitStartDate),
      end_date: getValidHistoryDate(state.historyDate?.visitEndDate),
    };

    controller.setState({ isMainLoading: true });

    const [r, allEn] = await Promise.all([historyVisit(controller, param), GetEncounterList(controller, { patient: state.patientId })]);

    let encounterLastId;
    if (allEn?.length > 0) {
      const uniqueIds = [...new Set(allEn.map((item: any) => item.id))];
      const latestId = Math.max(...uniqueIds);
      encounterLastId = allEn.find((item: any) => item.id === latestId);
    }

    if (r) {
      if (encounterLastId?.id) {
        await Promise.all([
          GetExamination(controller, { encounter: encounterLastId.id, visit: true }),
          GetPeriodontium(controller, { visit: true, encounterId: encounterLastId.id }),
        ]);
      }

      const encounterMap = new Map(allEn?.map((en) => [en.id, en]) || []);

      r.forEach((resp: any, number: any) => {
        let data: HistoryStateInitial.selectedHistoryVisit = {};
        Object.keys(HistoryStateInitial.selectedHistoryVisit).forEach((key) => {
          data[key] = resp[key];
        });

        if (resp.encounter && encounterMap.has(resp.encounter)) {
          const targetEncounter = encounterMap.get(resp.encounter);
          data["is_draft"] = targetEncounter.is_draft;
          data["status"] = targetEncounter.status;
          data["approve_by_name"] = targetEncounter.approve_by_name;
          data["student"] = targetEncounter.student;
          data["student_name"] = targetEncounter.student_name;
        }

        visitList.push(data);
      });

      const addDocId = r.map((item: any, index: number) => {
        return {
          ...item,
          id: index,
        };
      });

      const filterList = GetDoctorData(addDocId).map((data) => ({ ...data, is_selected: true }));
      const filterClinicList = GetClinicData(addDocId).map((data) => ({ ...data, is_selected: true }));

      controller.setState({
        cloneHistoryReviewVisitSearchData: [...addDocId],
        isMainLoading: false,
        doctorFilterList: filterList,
        clinicFilterList: filterClinicList,
      });
    }
  }

  controller.setState({
    historyReviewVisitData: visitList,
    selectedHistoryVisit: { ...HistoryStateInitial.selectedHistoryVisit },
  });
};

export const handleGetHistoryEx: Handler = async (controller) => {
  const state = controller.getState();

  let ExaminationList: any[] = [];
  if (controller.getState().patientId) {
    const param = {
      patient: state.patientId,
      start_date: getValidHistoryDate(state.historyDate?.exStartDate),
      end_date: getValidHistoryDate(state.historyDate?.exEndDate),
    };

    controller.setState({ isMainLoading: true });
    let clinicalAll = await GetDentalExamination(controller, param);
    clinicalAll = clinicalAll.sort((a, b) => formatDateToYYYYMMDD(b.started || "").localeCompare(formatDateToYYYYMMDD(a.started)));

    let encounterList: any[] = [...new Set(clinicalAll.map((item: any) => item.encounter))];

    const imagePromises = encounterList.map((encounterId) => GetExaminationImageList(controller, { encounter: encounterId }));

    const imageResults = await Promise.all(imagePromises);
    const imageItems = imageResults.flat();

    controller.handleEvent({ message: "GetPeriodontium", params: { history: true, encounterId: Math.max(...encounterList) } });

    console.log("handleGetHistoryEx clinicalAll: ", clinicalAll);
    if (clinicalAll) {
      const organItems = controller.data.organ.items;
      const clinicalTagsItems = controller.data.clinicaltags.items;

      const clinicalTagsMap = new Map(clinicalTagsItems.map((item) => [item.id, item.name]));
      const imagesByExaminationId = new Map();

      imageItems.forEach((img) => {
        if (!imagesByExaminationId.has(img.examination)) {
          imagesByExaminationId.set(img.examination, []);
        }
        imagesByExaminationId.get(img.examination).push(img);
      });

      clinicalAll.forEach((item: any) => {
        if (item.id) {
          if (item.locations_name.length > 0) {
            const locationsSet = getLocationsSet(item.locations_name, organItems);
            item.locations_name = tidyLocation2(locationsSet, organItems).join(",");
          }

          if (item.clinical_findings.length > 0) {
            item.clinicaltags = item.clinical_findings
              .map((id: number) => clinicalTagsMap.get(id))
              .filter(Boolean)
              .join(", ");
          }

          if (!item.medical_description) {
            item.medical_description = "";
          }

          const relatedImages = imagesByExaminationId.get(item.id);
          if (relatedImages && relatedImages.length > 0) {
            item.image = {};
            item.imageId = {};
            relatedImages.forEach((img) => {
              item.image[DentalTissueMapPane[img.tissue_name]] = img.image;
              item.imageId[DentalTissueMapPane[img.tissue_name]] = img.id;
            });
          }
        }
      });

      controller.setState({
        historyClinicalFindingList: clinicalAll,
        historyFilterClinicalFindingIds: clinicalAll.map((item) => item.id),
        historyClinicalFindingId: null,
        historyClinicalFindingIndex: null,
      });

      clinicalAll.forEach((resp) => {
        let data: HistoryStateInitial.selectedHistoryEx = {};
        Object.keys(HistoryStateInitial.selectedHistoryEx).forEach((key) => {
          data[key] = resp[key];
        });
        ExaminationList.push(data);
      });

      const addDocId = clinicalAll.map((item: any, index: number) => {
        return {
          ...item,
          id: index,
        };
      });

      const filterList = GetDoctorDataEx(addDocId).map((data) => ({ ...data, is_selected: true }));
      const filterClinicList = GetClinicData(addDocId).map((data) => ({ ...data, is_selected: true }));
      const filterLocationList = GetLocationData(controller, addDocId).map((data) => ({ ...data, is_selected: true }));
      const filterClinicalFindingList = GetClinicalFindingData(addDocId).map((data) => ({ ...data, is_selected: true }));

      controller.setState({
        cloneHistoryReviewExSearchData: [...addDocId],
        doctorFilterListEx: filterList,
        clinicFilterListEx: filterClinicList,
        locationFilterList: filterLocationList,
        clinicalFindingFilterList: filterClinicalFindingList,
      });
    }

    controller.setState({ historyReviewExData: ExaminationList, selectedHistoryEx: HistoryStateInitial.selectedHistoryEx, isMainLoading: false });
  }
};

export const handleGetHistoryTp: Handler = async (controller) => {
  console.log("handleGetHistoryTp: ");
  const state = controller.getState();

  let TreatmentList: any[] = [];
  let clinicalAll = [];
  console.log("handleGetHistoryTp controller.getState().patientId: ", controller.getState().patientId);
  let filterStatusCancelIdx = -1;

  if (controller.getState().patientId) {
    const paramC = {
      patient: state.patientId,
      start_date: getValidHistoryDate(state.historyDate?.tpStartDate),
      end_date: getValidHistoryDate(state.historyDate?.tpEndDate),
      inactive: true,
    };

    const paramExam = {
      patient: state.patientId,
      start_date: getValidHistoryDate(state.historyDate.exStartDate),
      end_date: getValidHistoryDate(state.historyDate.exEndDate),
    };

    controller.setState({ isMainLoading: true });

    const [allEn, clinicalAllResult, resTreatmentTypeC, resTreatmentIssue] = await Promise.all([
      GetEncounterList(controller, { patient: state.patientId }),
      GetDentalExamination(controller, paramExam),
      GetTreatmentPlan(controller, paramC, true),
      GetTreatmentIssue(controller, paramC),
    ]);

    clinicalAll = clinicalAllResult;
    console.log("resTreatmentIssue: ", resTreatmentIssue);

    let encounterLastId;
    if (allEn?.length > 0) {
      const uniqueIds = [...new Set(allEn.map((item) => item.id))];
      const latestId = Math.max(...uniqueIds);
      encounterLastId = allEn.find((item) => item.id === latestId);
    }

    const encounterList = [...new Set(clinicalAll.map((item) => item.encounter))];

    const imagePromises = encounterList.map((encounterId) => GetExaminationImageList(controller, { encounter: encounterId }));

    const imageResults = await Promise.all(imagePromises);
    const imageItems = imageResults.flat();

    console.log("handleGetHistoryTp clinicalAll: ", clinicalAll);

    const organItems = controller.data.organ.items;
    const clinicalTagsItems = controller.data.clinicaltags.items;

    const clinicalTagsMap = new Map(clinicalTagsItems.map((item) => [item.id, item.name]));
    const imagesByExaminationId = new Map();

    imageItems.forEach((img) => {
      if (!imagesByExaminationId.has(img.examination)) {
        imagesByExaminationId.set(img.examination, []);
      }
      imagesByExaminationId.get(img.examination).push(img);
    });

    clinicalAll.forEach((item) => {
      if (item.id) {
        if (item.locations_name.length > 0) {
          const locationsSet = getLocationsSet(item.locations_name, organItems);
          item.locations_name = tidyLocation2(locationsSet, organItems).join(",");
        }

        if (item.clinical_findings.length > 0) {
          item.clinicaltags = item.clinical_findings
            .map((id: number) => clinicalTagsMap.get(id))
            .filter(Boolean)
            .join(", ");
        }

        if (!item.medical_description) {
          item.medical_description = "";
        }

        const relatedImages = imagesByExaminationId.get(item.id);
        if (relatedImages && relatedImages.length > 0) {
          item.image = {};
          item.imageId = {};
          relatedImages.forEach((img) => {
            item.image[DentalTissueMapPane[img.tissue_name]] = img.image;
            item.imageId[DentalTissueMapPane[img.tissue_name]] = img.id;
          });
        }
      }
    });

    if (resTreatmentTypeC) {
      if (state.encounterId) {
        controller.handleEvent({
          message: "GetExamination",
          params: { encounter: controller.getState().encounterId, history: true },
        });
      }

      resTreatmentTypeC.forEach((resp) => {
        let data: TreatmentPlanStateInitial = {};
        Object.keys(TreatmentPlanStateInitial).forEach((key) => {
          data[key] = resp[key];
        });
        TreatmentList.push(data);
      });
    }

    const filterList = GetDoctorDataTp(TreatmentList).map((data) => ({ ...data, is_selected: true }));
    const filterClinicList = GetClinicDataTp(TreatmentList).map((data) => ({ ...data, is_selected: true }));
    const filterLocationList = GetLocationDataTp(TreatmentList).map((data) => ({ ...data, is_selected: true }));
    const filterStatusList = GetStatusData(TreatmentList).map((data) => ({ ...data, is_selected: true }));
    const filterTreatmentList = GetTreatmentDataTp(TreatmentList).map((data) => ({ ...data, is_selected: true }));
    const filterTreatmentCodeList = GetTreatmentCodeDataTp(TreatmentList).map((data) => ({ ...data, is_selected: true }));

    // Issue 67239 default no include cancel
    filterStatusCancelIdx = filterStatusList.findIndex((i) => i.name === "Cancelled");
    if (filterStatusCancelIdx !== -1) {
      filterStatusList[filterStatusCancelIdx].is_selected = false;
    }

    controller.setState({
      cloneHistoryReviewTpSearchData: [...TreatmentList],
      isMainLoading: false,
      doctorFilterListTp: filterList,
      clinicFilterListTp: filterClinicList,
      locationFilterListTp: filterLocationList,
      treatmentFilterListTp: filterTreatmentList,
      treatmentCodeFilterListTp: filterTreatmentCodeList,
      statusFilterList: filterStatusList,
    });
  }

  TreatmentList.sort((a, b) => b.id - a.id);
  console.log("TreatmentList: ", TreatmentList);

  controller.setState({
    historyReviewTpData: filterStatusCancelIdx !== -1 ? TreatmentList.filter((i) => i.status !== "X") : TreatmentList,
    historyTreatmentClinicalFindingList: clinicalAll,
    selectedHistoryTp: HistoryStateInitial.selectedHistoryTp,
  });
};

export const SetDoctorFilterVisit: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, locationFilter] = searchFilterVisit(controller, {
    key: "doctorFilterList",
    value: filter,
  });

  controller.setState({
    historyReviewVisitData: [...searchFilter],
    openModalFilter: false,
    doctorFilterList: locationFilter,
  } as any);
};

export const SetClinicFilter: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, clinicFilter] = searchFilterVisit(controller, {
    key: "clinicFilterList",
    value: filter,
  });

  controller.setState({
    historyReviewVisitData: [...searchFilter],
    openModalFilterClinic: false,
    clinicFilterList: clinicFilter,
  } as any);
};

export const SetClinicFilterEx: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, clinicFilter] = searchFilterEx(controller, {
    key: "clinicFilterListEx",
    value: filter,
  });

  controller.setState({
    historyReviewExData: [...searchFilter],
    openModalFilterClinicEx: false,
    clinicFilterListEx: clinicFilter,
  } as any);
};

export const SetClinicFilterTp: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, clinicFilter] = searchFilterTp(controller, {
    key: "clinicFilterListTp",
    value: filter,
  });

  controller.setState({
    historyReviewTpData: [...searchFilter],
    openModalFilterClinicTp: false,
    clinicFilterListTp: clinicFilter,
  } as any);
};

export const SetDoctorFilterEx: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, doctorFilter] = searchFilterEx(controller, {
    key: "doctorFilterListEx",
    value: filter,
  });

  controller.setState({
    historyReviewExData: [...searchFilter],
    openModalDoctorExFilter: false,
    doctorFilterListEx: doctorFilter,
  } as any);
};

export const SetDoctorFilterTp: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, doctorFilter] = searchFilterTp(controller, {
    key: "doctorFilterListTp",
    value: filter,
  });

  controller.setState({
    historyReviewTpData: [...searchFilter],
    openModalDoctorTpFilter: false,
    doctorFilterListTp: doctorFilter,
  } as any);
};

export const SetLocationFilter: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, locationFilter] = searchFilterEx(controller, {
    key: "locationFilterList",
    value: filter,
    level: "tissue__name",
  });

  controller.setState({
    historyReviewExData: [...searchFilter],
    openModalFilterLocation: false,
    locationFilterList: locationFilter,
  } as any);
};

export const SetLocationFilterTp: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, locationFilter] = searchFilterTp(controller, {
    key: "locationFilterListTp",
    value: filter,
  });

  controller.setState({
    historyReviewTpData: [...searchFilter],
    openModalFilterLocationTp: false,
    locationFilterListTp: locationFilter,
  } as any);
};

export const SetStatusFilter: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, statusFilter] = searchFilterTp(controller, {
    key: "statusFilterList",
    value: filter,
  });
  console.log("SetStatusFilter searchFilter: ", searchFilter);
  console.log("SetStatusFilter statusFilter: ", statusFilter);

  controller.setState({
    historyReviewTpData: searchFilter,
    openModalFilterStatus: false,
    statusFilterList: statusFilter,
  } as any);
};

export const SetClinicalFindingFilter: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, clinicalFindingFilter] = searchFilterEx(controller, {
    key: "clinicalFindingFilterList",
    value: filter,
    level: "group",
  });

  controller.setState({
    historyReviewExData: [...searchFilter],
    openModalFilterClinicalFinding: false,
    clinicalFindingFilterList: clinicalFindingFilter,
  } as any);
};

export const SetTreatmentCodeFilterTp: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, treatmentFilter] = searchFilterTp(controller, {
    key: "treatmentCodeFilterListTp",
    value: filter,
  });

  controller.setState({
    historyReviewTpData: searchFilter,
    openModalFilterTreatmentCodeTp: false,
    treatmentCodeFilterListTp: treatmentFilter,
  } as any);
};

export const SetTreatmentFilterTp: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, treatmentFilter] = searchFilterTp(controller, {
    key: "treatmentFilterListTp",
    value: filter,
  });

  controller.setState({
    historyReviewTpData: searchFilter,
    openModalFilterTreatmentTp: false,
    treatmentFilterListTp: treatmentFilter,
  } as any);
};

export const handleSetSelectedTreatmentRecord: Handler = (controller, params) => {
  const { row } = params;

  controller.setState({
    // treatmentRecord: row.treatment_issue.treatment_record,
    selectedHistoryTp: row,
    hideTreatmentForm: false,
  });
  // if(){
  //   cloneArr[activeIndexDiagram]
  // }
};

export const handleOpenModGallery: Handler = (controller, params) => {
  controller.setState({ openModGallery: params.data });
};


const getValidHistoryDate = (date?: string) => {
  if (!date) {
    return undefined;
  }

  const match = date.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);

  if (!match) {
    return undefined;
  }

  const [, day, month, year] = match;
  const normalizedDate = `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;

  return isValidDate(normalizedDate) ? normalizedDate : undefined;
};

const searchFilterTp: Handler = (controller, params) => {
  const { key, value } = params;
  const {
    cloneHistoryReviewTpSearchData,
    doctorFilterListTp,
    clinicFilterListTp,
    locationFilterListTp,
    treatmentFilterListTp,
    treatmentCodeFilterListTp,
    statusFilterList,
  } = controller.getState();

  console.log("searchFilterTp cloneHistoryReviewTpSearchData: ", cloneHistoryReviewTpSearchData);

  const data = {
    doctorFilterListTp,
    clinicFilterListTp,
    locationFilterListTp,
    treatmentFilterListTp,
    treatmentCodeFilterListTp,
    statusFilterList,
  };

  (data as any)[key] = (data as any)[key].map((list: any) => {
    return {
      ...list,
      is_selected: value.find((acc: any) => acc.name === list.name)?.is_selected || false,
    };
  });

  const searchFilter = (cloneHistoryReviewTpSearchData || []).filter((item) => {
    return (
      compareValue(data.treatmentFilterListTp, item.treatment?.name) &&
      compareValue(data.treatmentCodeFilterListTp, item.treatment_issue?.product_name) &&
      compareValue(data.statusFilterList, item.status_label) &&
      compareValue(data.locationFilterListTp, item.examination_location, "in") &&
      compareValue(data.clinicFilterListTp, item.division?.name) &&
      compareValue(data.doctorFilterListTp, item.doctor?.full_name)
    );
  });

  return [searchFilter, (data as any)[key]];
};

const searchFilterEx: Handler = (controller, params) => {
  const { key, value, level } = params;
  const { cloneHistoryReviewExSearchData, locationFilterList, doctorFilterListEx, clinicFilterListEx, clinicalFindingFilterList } = controller.getState();

  const data = {
    locationFilterList,
    doctorFilterListEx,
    clinicFilterListEx,
    clinicalFindingFilterList,
  };

  (data as any)[key] = (data as any)[key].map((list: any) => {
    const items = list.items?.map((item: any) => ({
      ...item,
      is_selected: value.find((acc: any) => acc[level] === list[level] && acc.name === item.name)?.is_selected || false,
    }));

    return {
      ...list,
      ...(level
        ? {
            is_selected: items.every((item: any) => item.is_selected),
            items: items,
          }
        : {
            is_selected: value.find((acc: any) => acc.name === list.name)?.is_selected || false,
          }),
    };
  });

  const searchFilter = (cloneHistoryReviewExSearchData || []).filter((item) => {
    return (
      compareValue(data.locationFilterList, item.locations_name, "in") &&
      // compareValue(data.doctorFilterListEx, item.doctor_name) &&
      compareValue(data.doctorFilterListEx, item.edit_user_name) &&
      compareValue(data.clinicFilterListEx, item.division_name) &&
      compareValue(data.clinicalFindingFilterList, item.clinical_findings_name, "in")
    );
  });

  return [searchFilter, (data as any)[key]];
};

const searchFilterVisit: Handler = (controller, params) => {
  const { key, value } = params;
  const { cloneHistoryReviewVisitSearchData, doctorFilterList, clinicFilterList } = controller.getState();

  const data = {
    doctorFilterList,
    clinicFilterList,
  };

  (data as any)[key] = (data as any)[key].map((list: any) => {
    return {
      ...list,
      is_selected: value.find((acc: any) => acc.name === list.name)?.is_selected || false,
    };
  });

  const searchFilter = (cloneHistoryReviewVisitSearchData || []).filter((item) => {
    return compareValue(data.doctorFilterList, item.doctor_fullname) && compareValue(data.clinicFilterList, item.division_name);
  });

  return [searchFilter, (data as any)[key]];
};

const historyVisit: Handler = async (controller, params) => {
  const [response, error, network] = await DentalMedicalHistoryList.list({
    apiToken: controller.apiToken,
    params: params,
  });
  if (error) {
    console.log("----- GetNurseNote error : ", error);
    return null;
  } else {

    return response?.items;
  }
};

const GetEncounterList: Handler = async (controller, params) => {
  const [encounterList, e, n] = await EncounterPatientListOptimized.get({
    apiToken: controller.apiToken,
    params: {
      ...(params || {}),
      limit: 99999,
    },
  });
  if (e) {
    console.log("Get Encounter List error:", e);
    return [];
  }
  return encounterList.items;
};

const GetTreatmentPlan = async (controller, params, format = false) => {
  const lang = controller.cookies.get("user_lang");

  const [response, error, network] = await TreatmentPlanList.list({
    apiToken: controller.apiToken,
    params,
    ...(lang && { extra: { headers: { "Accept-Language": lang } } }),
  });

  console.log("🚀 ~ file: DPOI.ts ~ line 1540 ~ GetTreatmentPlan ~ response", response);

  if (error) {
    console.log("----- GetTreatmentPlan error : ", error);
    return [];
  } else {
    if (format) {
      let result = [];
      response.items.forEach((resp) => {
        const masterOrgan = controller.data?.organ?.items;
        let data: TreatmentPlanStateInitial = {};
        Object.keys(TreatmentPlanStateInitial).forEach((key) => {
          if (key === "examination_location" && masterOrgan) {
            const locationsSet = getLocationsSet(resp[key], controller.data.organ.items);

            data[key] = tidyLocation2(locationsSet, masterOrgan).join(",");
          } else {
            data[key] = resp[key];
          }
        });
        result.push(data);
      });
      return result;
    }
  }
};

export const GetPeriodontium: Handler = async (controller, params) => {
  //- encounter = <id>
  // - patient = <id>
  const [r, e, n] = await PeriodontiumRecordList.list({
    apiToken: controller.apiToken,
    params: params,
  });
  if (e) {
    console.log(e);
    return [];
  }
  return r;
};

export const GetLocationData = (controller: any, DataList: any) => {
  const organItem = controller?.data?.organ?.items;

  let result: any[] = [];
  DataList?.forEach((list: any) => {
    if (list.locations_name !== "") {
      const locationsSet = list.locations_name
        .split(",")
        .map((item: any) => {
          let superTooth = controller.data.organ.items.find((o: any) => o.fullName === item);
          if (superTooth) {
            return superTooth.nickName;
          }
          return item.trim();
        })
        .filter((item: any) => item !== "");
      const locations_name = tidyLocation2(locationsSet, organItem).join(",");

      const index: number = result.map((rs) => rs.tissue__name).indexOf(list.locations_tissue_name?.[0]?.tissue__name);

      if (index < 0) {
        result.push({
          tissue__name: list.locations_tissue_name[0].tissue__name,
          is_selected: true,
          is_show: true,
          items: [{ name: locations_name, is_selected: true, is_show: true }],
        });
      } else {
        const found = result[index].items.some((rs: any) => rs.name === locations_name);
        if (!found) {
          result[index].items.push({ name: locations_name, is_selected: true, is_show: true });
        }
      }
    }
  });

  result.map((r: any) => r.items.sort((a: any, b: any) => ("" + a.name).localeCompare(b.name)));
  return result;
};


const compareValue = (data: any[] = [], value: any, operator: "eq" | "in" = "eq") => {
  if (!data[0] || !value) {
    return true;
  }

  data = data[0].items ? data.flatMap((item) => item.items) : data;

  if (operator === "eq") {
    return data.find((acc) => acc.is_selected && acc.name === value);
  } else if (operator === "in") {
    return data.find((acc) => acc.is_selected && value.includes(acc.name));
  }
  return false;
};

export const GetClinicalFindingData = (DataList: any) => {
  let result: any[] = [];
  DataList?.forEach((list: any) => {
    list.clinical_findings_group_name?.forEach((item: any) => {
      const index: number = result.map((rs) => rs.group).indexOf(item.group);

      if (index < 0) {
        result.push({
          group: item.group,
          is_selected: true,
          is_show: true,
          items: [{ name: item.name, is_selected: true, is_show: true }],
        });
      } else {
        const found = result[index].items.some((rs: any) => rs.name === item.name);
        if (!found) {
          result[index].items.push({ name: item.name, is_selected: true, is_show: true });
        }
      }
    });
  });

  result.map((r: any) => r.items.sort((a: any, b: any) => ("" + a.name).localeCompare(b.name)));
  return result;
};

export const GetClinicData = (DataList: any[]) => {
  const hasClinic = new Map();
  const doctorData = [];

  for (const list of DataList) {
    if (!hasClinic.has(list.division_name)) {
      doctorData.push({
        name: list.division_name,
      });
      hasClinic.set(list.division_name, hasClinic.size);
    }
  }
  return doctorData.sort((a, b) => ("" + a.name).localeCompare(b.name));
};

export const GetClinicDataTp = (DataList: any[]) => {
  const hasClinic = new Map();
  const doctorData = [];

  for (const list of DataList) {
    if (list.division != null) {
      if (!hasClinic.has(list.division.name)) {
        doctorData.push({
          name: list.division.name,
        });
        hasClinic.set(list.division.name, hasClinic.size);
      }
    }
  }

  return doctorData.sort((a, b) => ("" + a.name).localeCompare(b.name));
};

export const GetDoctorData = (DataList: any[]) => {
  const hasDoctor = new Map();
  const doctorData = [];

  for (const list of DataList) {
    if (!hasDoctor.has(list.doctor_fullname)) {
      doctorData.push({
        name: list.doctor_fullname,
      });
      hasDoctor.set(list.doctor_fullname, hasDoctor.size);
    }
    // for (const item of list) {
    //   if (!hasDoctor.has(item.doctor_id) && item.doctor_id) {
    //     doctorData.push({
    //       id: item.doctor_id,
    //       name: item.doctor_fullname
    //     })
    //     hasDoctor.set(item.doctor_id, hasDoctor.size);
    //   }
    // }
  }

  return doctorData.sort((a, b) => ("" + a.name).localeCompare(b.name));
};

export const GetDoctorDataEx = (DataList: any[]) => {
  const hasDoctor = new Map();
  const doctorData = [];

  for (const list of DataList) {
    // if (!hasDoctor.has(list.doctor_name)) {
    //   doctorData.push({
    //     name: list.doctor_name,
    //   });
    //   hasDoctor.set(list.doctor_name, hasDoctor.size);
    // }
    if (!hasDoctor.has(list.edit_user_name)) {
      doctorData.push({
        name: list.edit_user_name,
      });
      hasDoctor.set(list.edit_user_name, hasDoctor.size);
    }
  }

  return doctorData.sort((a, b) => ("" + a.name).localeCompare(b.name));
};

export const GetDoctorDataTp = (DataList: any[]) => {
  const hasDoctor = new Map();
  const doctorData = [];

  for (const list of DataList) {
    if (list.doctor != null) {
      if (!hasDoctor.has(list.doctor.full_name)) {
        doctorData.push({
          name: list.doctor.full_name,
        });
        hasDoctor.set(list.doctor.full_name, hasDoctor.size);
      }
    }
  }

  return doctorData.sort((a, b) => ("" + a.name).localeCompare(b.name));
};

export const GetLocationDataTp = (DataList: any[]) => {
  const hasLocation = new Map();
  const locationData = [];

  for (const list of DataList) {
    for (const item of list.examination_location.split(",")) {
      console.log("item locations_name", item);
      if (!hasLocation.has(item) && item) {
        locationData.push({
          name: item,
        });
        hasLocation.set(item, hasLocation.size);
      }
    }
  }

  return locationData.sort((a, b) => ("" + a.name).localeCompare(b.name));
};

export const GetStatusData = (DataList: any[]) => {
  const hasDoctor = new Map();
  const statusData = [];

  for (const list of DataList) {
    if (!hasDoctor.has(list.status_label)) {
      statusData.push({
        name: list.status_label,
      });
      hasDoctor.set(list.status_label, hasDoctor.size);
    }
  }

  return statusData.sort((a, b) => ("" + a.name).localeCompare(b.name));
};

export const GetTreatmentCodeDataTp = (DataList: any[]) => {
  const hasTreatment = new Map();
  const treatmentData = [];
  console.log("DataList", DataList);
  for (const list of DataList) {
    if (list?.treatment_issue?.product_name && !hasTreatment.has(list.treatment_issue.product_name)) {
      treatmentData.push({
        name: list.treatment_issue.product_name,
      });
      hasTreatment.set(list.treatment_issue.product_name, hasTreatment.size);
    }
  }

  return treatmentData.sort((a, b) => ("" + a.name).localeCompare(b.name));
};

export const GetTreatmentDataTp = (DataList: any[]) => {
  const hasTreatment = new Map();
  const treatmentData = [];

  for (const list of DataList) {
    if (list?.treatment?.name && !hasTreatment.has(list.treatment.name)) {
      treatmentData.push({
        name: list.treatment.name,
      });
      hasTreatment.set(list.treatment.name, hasTreatment.size);
    }
  }

  return treatmentData.sort((a, b) => ("" + a.name).localeCompare(b.name));
};

